export default __webpack_public_path__ + "static/media/lucky_draw.40294188.png";